import React, { Fragment, Component } from "react";
import _get from "lodash/get";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { asyncValidate, shouldAsyncValidate } from "redux-form-yup";
import { Field, reduxForm, getFormValues } from "redux-form";
import compose from "ramda/src/compose";
import values from "ramda/src/values";
import mapObjIndexed from "ramda/src/mapObjIndexed";

import {
  Button,
  FloatLabelComponent,
  FloatLabelInput,
  FloatLabelSelect,
  Form,
} from "shared/components";
import styles from "./styles.css";
import Loading from "components/Loading";
import ModalError from "components/ModalError";
import ModalSuccess from "components/ModalSuccess";
import SingleDate from "../../../../components/SingleDatePicker";
import { postScheduling } from "../../../../services/state/actions";
import * as Mask from "services/utils/mask";
import * as Yup from "yup";
import moment from "moment";
import { PERIOD } from "services/state/rescheduling/constants";
moment.locale("pt-br");

class RescheduleForm extends Component {
  state = {
    modalOpen: false,
  };

  onCloseErrorModal = () => {
    window.location = "/";
  };

  successModal = () => {
    this.setState({
      modalOpen: true,
    });
  };

  rescheduleSubmit = (values) => {
    const { postScheduling, demand, customer } = this.props;
    postScheduling(values, demand, customer, () => this.successModal());
  };

  datePickerField = (field, value) => {
    const { t, change } = this.props;

    return (
      <FloatLabelComponent
        id="subject"
        name="subject"
        onChange=""
        label={t("MSG_0235")}
        value=""
      >
        <SingleDate
          {...field.input}
          id="date_input"
          anchorDirection="right"
          date={value}
          onDateChange={(date) => change("datePicker", date)}
        />
      </FloatLabelComponent>
    );
  };

  renderInputField = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;

    return (
      <FloatLabelInput
        {...field.input}
        id={field.id}
        type={field.type}
        label={field.label}
        maxLength={field.maxLength}
        invalid={touched && invalid}
        error={error}
      />
    );
  };

  renderSelectField = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    const options = values(
      mapObjIndexed((label, value) => ({ label, value }), field.options)
    );

    return (
      <FloatLabelSelect
        id={field.id}
        options={options}
        label={field.label}
        invalid={touched && invalid}
        error={error}
        defaultOption
        {...field.input}
      />
    );
  };

  render() {
    const {
      demand,
      t,
      handleSubmit,
      reschedulingFormValues,
      loading,
      error,
    } = this.props;
    const { modalOpen } = this.state;

    return (
      <Fragment>
        <Form onSubmit={handleSubmit(this.rescheduleSubmit)}>
          <div className={styles.detailsWrapper}>
            <div>
              <label className={styles.titleDetails}>{t("MSG_0288")}:</label>
              <br />
              <span id="protocol" className={styles.information}>
                {demand.closeDate}
              </span>
            </div>
            <div>
              <Field
                id="datePicker"
                name="datePicker"
                component={(field) =>
                  this.datePickerField(
                    field,
                    _get(reschedulingFormValues, "datePicker")
                  )
                }
              />
            </div>
          </div>
          <div className={styles.detailsWrapper}>
            <div className={styles.period}>
              <Field
                id="period"
                name="period"
                label={t("PERIOD")}
                options={PERIOD}
                component={this.renderSelectField}
              />
            </div>
            <div className={styles.phoneNumber}>
              <Field
                id="phoneNumber"
                name="phoneNumber"
                label={t("MSG_0017")}
                component={this.renderInputField}
                format={Mask.phone}
                maxLength="15"
                normalize={Mask.algarPhone}
              />
            </div>
          </div>
          <hr />
          <div className={styles.action}>
            <Button relevance="normal" type="submit" callToAction weight="thin">
              {t("MSG_0235")}
            </Button>
          </div>
        </Form>
        <Loading isOpen={loading} />

        <ModalError
          isOpen={error}
          onClose={this.onCloseErrorModal}
          msg={t("MSG_0272")}
        />

        <ModalSuccess
          isOpen={modalOpen}
          onClose={this.onCloseErrorModal}
          msg={t("RESCHEDULE_SUCCESS")}
        />
      </Fragment>
    );
  }
}

const createValidationSchema = () => {
  return Yup.object().shape({
    datePicker: Yup.string().required("Campo obrigatório"),

    period: Yup.string().required("Campo obrigatório"),

    phoneNumber: Yup.string()
      .required("Campo obrigatório")
      .matches(/^0\d{1,14}$/, {
        message: "Número de telefone inválido",
        excludeEmptyString: true,
      }),
  });
};

const mapStateToProps = (state) => ({
  rescheduling: state.rescheduling,
  loading: state.rescheduling.loading,
  error: state.rescheduling.error,
  initialValues: {
    datePicker: moment(),
  },
  reschedulingFormValues: getFormValues("ReschedulingForm")(state),
});

const reduxFormConfig = {
  form: "ReschedulingForm",
  asyncValidate: asyncValidate(createValidationSchema()),
  shouldAsyncValidate,
};

const enhance = compose(
  translate(),
  connect(mapStateToProps, { postScheduling }),
  reduxForm(reduxFormConfig)
);

export default enhance(RescheduleForm);



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/RescheduleForm/index.js